// extracted by mini-css-extract-plugin
export default {"container":"DeleteAccount_container__wc6hS","form":"DeleteAccount_form__i5DKY"};